import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Title from "./Title";
import CsvDownloadButton from "react-json-to-csv";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import DashboardTable from "./DashboardTable";
import EditUser from "./EditUser";
import { fetchUsers, fetchTypes } from "../../apis/UserAPI";
import { fetchCompanies } from "../../apis/CompanyAPI";
import Switch from "@mui/material/Switch";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";

function Users() {
  const [users, setUsers] = useState([]);
  const [types, setTypes] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setUsers(await fetchUsers());
        setTypes(await fetchTypes());
        setCompanies(await fetchCompanies());
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error, show error message, etc.
      }
    };
    fetchData();
  }, []);  

  const columns = [
    "User ID",
    "Type",
    "Name",
    "Email",
    "Company",
    "Status"
  ];

  const columnMapping = {
    "User ID": "uid",
    "Type": "user_type",
    "Name": "name",
    "Email": "contact",
    "Company": "company_name",
    "Status": "is_active"
  };

  const formatValues = {
    "Status": (value, row) => {
        if (value === 1 || value === true) {
            if (row.company_is_active === 0 || row.company_is_active === false) {
                return <span style={{color: 'orange'}}>Active (Company Inactive)</span>;
            }
            return "Active";
        }
        return "Inactive";
    }
  };

  const handleUserAdded = async () => {
    // After a company is added, refetch the list of companies
    try {
      const updatedUsers = await fetchUsers();
      const updatedTypes = await fetchTypes();
      setUsers(updatedUsers);
      setTypes(updatedTypes);
    } catch (error) {
      console.error("Error fetching data after addition:", error);
      // Handle error, show error message, etc.
    }
  };

  const filteredUsers = showInactive
    ? users
    : users.filter(u => 
        (u.is_active !== 0 && u.is_active !== false) && 
        (u.company_is_active !== 0 && u.company_is_active !== false)
      );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <React.Fragment>
            <Title>
              Users
              <FilterListIcon 
                onClick={() => setShowFilters(!showFilters)}
                sx={{
                  color: "black",
                  background: "none",
                  border: "none",
                  float: "right",
                  margin: "0px 0px 0px 10px",
                  cursor: "pointer"
                }}
              />
              <CsvDownloadButton
                data={filteredUsers}
                filename={"User List.csv"}
                style={{
                  background: "none",
                  border: "none",
                  float: "right",
                  cursor: "pointer"
                }}
              >
                <FileDownloadOutlinedIcon />
              </CsvDownloadButton>
              <EditUser data={users} onUserEditted={handleUserAdded} types={types} companies={companies}/>
            </Title>
            
            <Collapse in={showFilters}>
              <Box sx={{ 
                p: 2.5, 
                mb: 2, 
                backgroundColor: '#fafafa', 
                borderRadius: 2,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                border: '1px solid #e0e0e0'
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Switch
                    checked={showInactive}
                    onChange={(e) => setShowInactive(e.target.checked)}
                    name="showInactive"
                    color="primary"
                  />
                  <Box sx={{ fontSize: '0.95rem', color: '#424242' }}>
                    Show Inactive Users
                  </Box>
                </Box>
              </Box>
            </Collapse>
            
            <DashboardTable data={filteredUsers} columns={columns} columnMapping={columnMapping} refreshData={fetchUsers} formatValues={formatValues}/>
          </React.Fragment>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default Users;
